import { array, boolean, number, object, string } from 'yup'

import { LotteryTicketType } from '../lottery'

export const addOnSchema = object({
  name: string().required(),
  value: string().defined().strict(true),
})

export const prepaidSubscriptionOptionSchema = object({
  label: string().required(),
  value: number().required(),
})

export const playSlipPlaySchema = object({
  fields: array(
    object({
      name: string().required(),
      selected: array(number().integer().required()).required(),
    }),
  ).required(),
  id: string().required(),
  isComplete: boolean().required(),
  isDirty: boolean().required(),
  isQuickPick: boolean().required(),
  isValid: boolean().required(),
  key: string().required(),
  perPlayAddOn: addOnSchema.nullable().default(null),
  stake: string().nullable().default(null),
})

export const quickPickBetType = string().required().nullable()
export const quickPickNumbers = array().of(number().required().nullable()).required().nullable()
export const quickPickQuantity = number().required()
export const quickPickWager = number().required().nullable()

export const quickPickSchema = object({
  betType: quickPickBetType,
  numbers: quickPickNumbers,
  quantity: quickPickQuantity,
  wager: quickPickWager,
})

export const configVersionSchema = object().test(
  'configVersion',
  'Must be a record of config version strings',
  (value) => {
    if (typeof value !== 'object' || value === null) return false
    return Object.values(value).every((version) => typeof version === 'string')
  },
)

export const playSlipPlaysSchema = object().test(
  'plays',
  'Must be a record of PlaySlipPlay arrays',
  (value) => {
    if (typeof value !== 'object' || value === null) return false
    return Object.values(value).every(
      (arr) => Array.isArray(arr) && arr.every((play) => playSlipPlaySchema.isValidSync(play)),
    )
  },
)

export const prepaidSubscriptionAmountSchema = object().test(
  'prepaidSubscriptionAmount',
  'Must be a record of PrepaidSubscriptionOption or null/undefined',
  (value) => {
    if (typeof value !== 'object' || value === null) return false
    return Object.values(value).every(
      (opt) => opt == null || prepaidSubscriptionOptionSchema.isValidSync(opt),
    )
  },
)

export const quickPickSettingsSchema = object().test(
  'quickPickSettings',
  'Must be a record of QuickPickSettings',
  (value) => {
    if (typeof value !== 'object' || value === null) return false
    return Object.values(value).every((opt) => opt == null || quickPickSchema.isValidSync(opt))
  },
)

export const selectedAddOnsSchema = object().test(
  'lotterySelectedAddOns',
  'Must be a record of AddOn arrays',
  (value) => {
    if (typeof value !== 'object' || value === null) return false
    return Object.values(value).every(
      (arr) => Array.isArray(arr) && arr.every((addon) => addOnSchema.isValidSync(addon)),
    )
  },
)

export const ticketTypeSchema = object().test(
  'ticketType',
  'Must be a record of LotteryTicketType',
  (value) => {
    if (typeof value !== 'object' || value === null) return false
    const validTypes = Object.values(LotteryTicketType)
    return Object.values(value).every((v) => validTypes.includes(String(v) as LotteryTicketType))
  },
)

export const lotteryLocalStateSchema = object().shape({
  configVersion: configVersionSchema.required().default({}),
  plays: playSlipPlaysSchema.required(),
  prepaidSubscriptionAmount: prepaidSubscriptionAmountSchema.required(),
  quickPickSettings: quickPickSettingsSchema.required().default({}),
  selectedAddOns: selectedAddOnsSchema.required().default({}),
  ticketType: ticketTypeSchema.required().default({}),
})
